<template>
  <div v-if="myMachines && numCurrentMachine > 0">
    <oie-base-action
      theme="flat"
      @click="setActiveSlideIn('machines-quick-look-slide-in')">
      {{ quickLookText }}
    </oie-base-action>
    <oie-portal-wrapper name="machines-quick-look-slide-in">
      <template #title>
        <h2>{{ title }}</h2>
      </template>
      <div v-if="selectedEntity" class="my-machines-quick-look__selectedEntity">
        <oie-base-action
          theme="flat"
          @click="selectedEntity = null">
          <template #iconPrepend>
            <oie-base-icon icon="arrow-left" size="s"></oie-base-icon>
          </template>
          {{ tStatic('goBack') }}
        </oie-base-action>
        <oie-machine-owner-information v-if="isMachineOwner" :machine-owner="selectedEntity"></oie-machine-owner-information>
        <oie-machine-information v-else :machine="selectedEntity"></oie-machine-information>
      </div>
      <div v-else class="my-machines-quick-look__machines">
        <oie-my-machines-list-wrapper v-if="filteredMachineOwners.length > 0">
          <template #title>
            <h2>
              {{ tStatic('machineOwnersTitle') }}
            </h2>
          </template>
          <li v-for="customer in filteredMachineOwners" :key="`customer-${customer.machineOwnerId}`">
            <oie-machine-owner-item
              :customer="customer"
              @select-machine-owner="handleSelect"
              @select-machine="handleSetGlobalSelection">
              <template #machine-actions="{ machine }">
                <oie-base-action
                  v-tooltip.top="tStatic('goToMachine')"
                  theme="flat"
                  @click="handleSelect(machine)">
                  <oie-base-icon
                    icon="machine-inspect"
                    size="xs"></oie-base-icon>
                </oie-base-action>
              </template>
            </oie-machine-owner-item>
          </li>
        </oie-my-machines-list-wrapper>
        <oie-my-machines-list-wrapper v-if="filteredMachines.length > 0">
          <template #title>
            <h2>
              {{ tStatic('machinesTitle') }}
            </h2>
          </template>
          <li v-for="machine in filteredMachines" :key="`machine-${machine.machineId}`">
            <oie-machine-item
              v-tooltip.top="tStatic('selectMachine')"
              :machine="machine"
              @select-machine="handleSetGlobalSelection">
              <template #actions>
                <oie-base-action
                  v-tooltip.top="tStatic('goToMachine')"
                  theme="flat"
                  @click="handleSelect">
                  <oie-base-icon
                    icon="machine-inspect"
                    size="xs"></oie-base-icon>
                </oie-base-action>
              </template>
            </oie-machine-item>
          </li>
        </oie-my-machines-list-wrapper>
      </div>
    </oie-portal-wrapper>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import myMachineService from '@/core/my-machines-service'
import _ from 'lodash'

export default {
  data() {
    return {
      selectedEntity: null
    }
  },
  computed: {
    ...mapGetters('myMachines', ['myMachines']),
    filteredMachineOwners() {
      return myMachineService.filterMachineOwners(_.cloneDeep(this.myMachines.machineOwners), this.clientModel.currentVehicle.itemId, 'all')
    },
    filteredMachines() {
      return myMachineService.filterMachines(_.cloneDeep(this.myMachines.machines), this.clientModel.currentVehicle.itemId, 'all')
    },
    numCurrentMachine() {
      const ownedMachinesOfModel = _.sumBy(this.filteredMachineOwners, owner => {
        return _.filter(owner.machines, machine => machine.model === this.clientModel.currentVehicle.itemId).length
      })
      return ownedMachinesOfModel + this.filteredMachines.length
    },
    quickLookText() {
      return this.tStatic('quickLookText').replace('{0}', this.numCurrentMachine)
    },
    title() {
      return this.selectedEntity ? this.selectedEntity.name : this.quickLookText
    },
    isMachineOwner() {
      return !!this.selectedEntity.ownerType
    }
  },
  methods: {
    ...mapActions('ui', ['setActiveSlideIn']),
    ...mapActions('myMachines', ['setGlobalMyMachinesSelection']),
    handleSelect($event) {
      this.selectedEntity = $event
    },
    handleSetGlobalSelection(entity) {
      this.setGlobalMyMachinesSelection(entity)
      this.setActiveSlideIn(null)
    }
  }
}

</script>

<style lang="scss">
.my-machines-quick-look__selectedEntity > * {
  margin-bottom: measure(quarter);
}

.my-machines-quick-look__machines > * {
  margin-bottom: measure(quarter);
}
</style>
